import { Routes, RouterModule } from "@angular/router";
import { OneCardExpressComponent } from "./index";
import { ExpressComponent } from "./express/express.component";
import { ExpressAdminComponent } from "./expressadmin/expressadmin.component";
import { AuthguardService } from "../master/services";

export const OneCardExpressRoutes: Routes = [
	{
		path: "",
		redirectTo: "/onecardexpress/onecardexpress",
		pathMatch: "full",
	},
	{
		path: "onecardexpress",
		data: { title: "OneCard Express" },
		component: ExpressComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "onecardexpresssu",
		data: { title: "OneCard Express (SU Only)" },
		component: ExpressAdminComponent,
		canActivate: [AuthguardService],
	},
];
